import React from "react";

function Test() {
  return (
    <>
      <b>List of I have created for testing:</b>
      <table className="min-w-max text-center p-2">
        <thead>
          <tr>
            <th scope="col" class="text-sm font-medium text-gray-900 px-6 py-4">
              Email
            </th>
            <th scope="col" class="text-sm font-medium text-gray-900 px-6 py-4">
              Password
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>shahjalal@gmail.com</td>
            <td>1111</td>
          </tr>
          <tr>
            <td>anik@gmail.com</td>
            <td>1111</td>
          </tr>
          <tr>
            <td>rony@gmail.com</td>
            <td>1111</td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default Test;
